import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle2, X } from "lucide-react";
import { stampPassport, getPassport } from "../../data/artForms";

/**
 * Floating "Stamp earned!" toast + persistence.
 * Call stampPassport(id) when the activity is completed (e.g., on save).
 */
export function useStamp(artFormId) {
  const [showToast, setShowToast] = useState(false);

  const earn = () => {
    const passport = getPassport();
    if (!passport[artFormId]) {
      stampPassport(artFormId);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 4500);
    }
  };

  return { earn, showToast, dismiss: () => setShowToast(false) };
}

export function StampToast({ show, artName, onDismiss }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.96 }}
          className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 max-w-md w-[90vw]"
          data-testid="stamp-toast"
        >
          <div className="bg-[#1E2A4F] text-[#F9F6F0] rounded-2xl shadow-2xl border-2 border-[#D95D39] p-5 flex items-center gap-4">
            <span className="w-12 h-12 rounded-full bg-[#D95D39] flex items-center justify-center shrink-0">
              <CheckCircle2 size={24} />
            </span>
            <div className="flex-1">
              <p className="overline !text-[#E76F51]">Stamp earned!</p>
              <p className="font-display text-xl leading-tight mt-1">
                You completed <em className="italic font-light">{artName}</em>
              </p>
            </div>
            <button
              onClick={onDismiss}
              data-testid="stamp-toast-close"
              className="w-8 h-8 rounded-full hover:bg-[#F9F6F0]/10 flex items-center justify-center"
              aria-label="Close"
            >
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
